export default "__VITE_ASSET__N7Esa0QD__"